<div class="choose-customer-menu-container flexColumnParent">
    <ac-search *ngIf="entities.length > 3"
               (searchChange)="searchEvent($event)"
               class="flexItem"
               componentId="search-field">
    </ac-search>

    <div class="flexItemBiggest flexColumnParent">
        <ng-container *ngFor="let entity of (searchedEntities || entities)">
            <mat-card (click)="entitySelectionChanged(entity)">
                <div  class="flexRowParent card-container">
                    <div class="logo-container">
                        <img *ngIf="entity.logo && entity.logo !== -1" [src]="entity.logo"/>

                        <div class="empty-logo" *ngIf="!entity.logo || entity.logo === -1">
                            <ac-svg name="lcCustomer" [fillColor]="statusColors.primary"></ac-svg>
                        </div>
                    </div>

                    <mat-divider></mat-divider>

                    <div class="flexColumnParent card-details">
                        <div class="flexRowParent card-type">
                            <span>{{entity.entityType.toLowerCase() === 'tenant' ? 'Service Provider' : entity.entityType}}</span>
                        </div>
                        <div class="card-header" acLabel>{{entity.name}}</div>
                        <div class="card-footer flexColumnParent">
                            <div *ngIf="entity.entityType.toLowerCase() !== 'tenant'" class="flexRowParent">
                                <span class="card-key">Service Provider:</span>
                                <span acLabel>{{(entity | acFunc: getParentByType: 'tenant').name}}</span>
                            </div>

                            <div class="flexRowParent">
                                <span class="card-key">Security Level:</span>
                                <span acLabel>{{entity.securityLevel}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </mat-card>
        </ng-container>
    </div>
</div>
